export default (url) =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src   = url
    script.addEventListener('load', resolve)
    script.addEventListener('error', reject)
    document.head.append(script)
  })
